export default __webpack_public_path__ + "images/am-e935f82147f4d3c76c9284797c6f2a20.svg";